// @ts-check
/**
 * Cvičné texty pre voľné písanie.
 *
 * LICENCIE: všetky texty v tomto súbore sú vlastné (napísané pre tento projekt)
 * a uvoľnené ako CC0-1.0. Zámerne tu NIE SÚ texty z atfonline.sk ani iné cudzie
 * texty — tie sú chránené autorským právom. Ak chce zadávateľ literatúru,
 * treba doplniť len diela vo verejnom vlastníctve a v metadátach uviesť autora.
 *
 * @typedef {Object} PracticeText
 * @property {string} id
 * @property {string} title
 * @property {string} author
 * @property {string} license
 * @property {'ľahká'|'stredná'|'ťažká'} difficulty
 * @property {boolean} diacritics
 * @property {string[]} paragraphs
 */

/** @type {PracticeText[]} */
export const PRACTICE_TEXTS = [
  {
    id: 't-01',
    title: 'Ráno v meste',
    author: 'vlastný text',
    license: 'CC0-1.0',
    difficulty: 'ľahká',
    diacritics: false,
    paragraphs: [
      'Rano sa mesto pomaly prebuda. Prve autobusy idu po prazdnej ceste a pekari otvaraju svoje obchody. Na namesti stoji stary clovek a cita noviny.',
      'Deti idu do skoly so taskami na pleciach. Križovatka je plna ludi, ktori sa ponahlaju do prace. V malej kaviarni vonia kava a cerstvy chlieb.',
    ],
  },
  {
    id: 't-02',
    title: 'Les na jeseň',
    author: 'vlastný text',
    license: 'CC0-1.0',
    difficulty: 'ľahká',
    diacritics: false,
    paragraphs: [
      'Na jesen sa les oblieka do zlata a cervena. Listy pomaly padaju na zem a pod nohami sucho praskaju. Vzduch je chladny a voňa po hriboch.',
      'Veverica skace z konara na konar a hlada oriešky. My sa vracame domov po uzkej ceste a nesieme si plny kos hub.',
    ],
  },
  {
    id: 't-03',
    title: 'Ako sa učiť písať všetkými desiatimi',
    author: 'vlastný text',
    license: 'CC0-1.0',
    difficulty: 'stredná',
    diacritics: false,
    paragraphs: [
      'Kazdy, kto sa chce naucit pisat vsetkymi desiatimi, musi najprv znat domovsku poziciu. Prsty polozis na klavesy a, s, d, f a j, k, l, bodkociarku a vzdy sa na ne vracaju.',
      'Najprv je pisanie pomale a clovek mysli na kazdy prst. Po par tyzdnoch sa pohyby zautomatizuju a clovek zacne mysliet len na text. Vtedy rychlost rastie sama.',
      'Dolezite je pisat pravidelne kratko, nie raz za tyzden dlho. Desat minut kazdy den prinasa viac nez dve hodiny v sobotu.',
    ],
  },
  {
    id: 't-04',
    title: 'Malá dedina pod Tatrami',
    author: 'vlastný text',
    license: 'CC0-1.0',
    difficulty: 'stredná',
    diacritics: true,
    paragraphs: [
      'Pod Tatrami leží malá dedina, kde sa ráno ozýva zvonec a večer vôňa dreva z komínov. Ľudia tu chodia pešo, pretože obchod je blízko a cesta je úzka.',
      'V zime sneh zavrie priesmyk a dedina zostane sama so sebou. Vtedy sa susedia navštevujú, varia čaj a rozprávajú príbehy, ktoré si pamätajú ešte z detstva.',
      'Na jar sa lúky zazelenajú a ovce sa vrátia na svahy. Každý rok je to isté a každý rok sa na to ľudia tešia rovnako.',
    ],
  },
  {
    id: 't-05',
    title: 'Kôň, ktorý sa bál búrky',
    author: 'vlastný text',
    license: 'CC0-1.0',
    difficulty: 'stredná',
    diacritics: true,
    paragraphs: [
      'Kôň menom Žiar mal rád ticho. Keď sa nad horou začali zhromažďovať čierne mraky, stiahol uši a triasol sa. Sedliak ho vždy chytil za uzdu a hovoril mu pokojne.',
      'Jedného dňa prišla búrka taká silná, že sa zatriasli aj okná. Žiar vybehol na dvor a bežal k stodole. Tam ho čakala dlaň plná ovsa a ticho, ktoré mal tak rád.',
    ],
  },
  {
    id: 't-06',
    title: 'Škola v septembri',
    author: 'vlastný text',
    license: 'CC0-1.0',
    difficulty: 'stredná',
    diacritics: true,
    paragraphs: [
      'V septembri sa školy naplnia hlukom a vôňou nových zošitov. Žiaci si sadnú do lavíc, učitelia rozdajú rozvrhy a prvý deň sa nič vážne neudeje.',
      'Potom prídu testy, diktáty a písomky. Kto sa cez leto aspoň občas učil, tomu to ide ľahšie. Kto nie, musí doháňať a to bolí.',
    ],
  },
  {
    id: 't-07',
    title: 'Cesta vlakom',
    author: 'vlastný text',
    license: 'CC0-1.0',
    difficulty: 'stredná',
    diacritics: true,
    paragraphs: [
      'Vlak vyšiel zo stanice presne o siedmej. Okolo okna sa míňali polia, dediny a jeden starý most. Cestujúci čítali knihy alebo spali s hlavou na skle.',
      'V Trebišove pribudlo pár ľudí, v Košiciach sa vyprázdnil celý vozeň. Potom prišiel sprievodca, skontroloval lístky a zaželal dobrú cestu.',
    ],
  },
  {
    id: 't-08',
    title: 'Záhrada za domom',
    author: 'vlastný text',
    license: 'CC0-1.0',
    difficulty: 'ľahká',
    diacritics: true,
    paragraphs: [
      'Za domom máme malú záhradu. Rastie v nej petržlen, mrkva, cibuľa a tri kríčky ríbezlí. Babka ich každé ráno polieva a hovorí, že rastliny cítia, keď sa o ne staráme.',
      'V júli dozrejú čerešne a vtedy je záhrada najkrajšia. Deti sa na ne vyškriabu a vrátia sa dolu s červenými ústami.',
    ],
  },
  {
    id: 't-09',
    title: 'Prvý deň v novej práci',
    author: 'vlastný text',
    license: 'CC0-1.0',
    difficulty: 'ťažká',
    diacritics: true,
    paragraphs: [
      'Prišiel som o pol ôsmej, o dvadsať minút skôr, než bolo treba. Vrátnik ma poslal na tretie poschodie a ja som sa vo výťahu snažil vyzerať pokojne.',
      'Kolegovia boli milí, ale ich mená som si pomýlil ešte trikrát. Prvý deň sa nehodnotí podľa výkonu, ale podľa toho, či si človek zapamätá, kde je kávovar a kedy je obed.',
      'Večer som prišiel domov unavený a spokojný. Vedel som, že to bude trvať, kým sa všetko naučím, ale prvý krok bol za mnou.',
    ],
  },
  {
    id: 't-10',
    title: 'Noc nad mestom',
    author: 'vlastný text',
    license: 'CC0-1.0',
    difficulty: 'ťažká',
    diacritics: true,
    paragraphs: [
      'Mesto v noci vyzerá inak. Ulice sa vyprázdnia, svetlá pouličných lámp kreslia na chodník dlhé tiene a z okien svietia len jednotlivé byty.',
      'Niekto ešte pracuje, niekto sa učí na skúšku, niekto len nemôže spať. Nad strechami je ticho, ktoré cez deň neexistuje, a obloha je plná svetla, ktoré k nám letelo tisíce rokov.',
    ],
  },
];

/**
 * Rozdelí text na riadky vhodné na písanie (zachová odstavce).
 * @param {PracticeText} text
 * @returns {string[]}
 */
export function textToLines(text) {
  /** @type {string[]} */
  const lines = [];
  for (const paragraph of text.paragraphs) {
    const words = paragraph.split(' ');
    let current = '';
    for (const word of words) {
      if ((current + ' ' + word).trim().length > 68) {
        lines.push(current.trim());
        current = word;
      } else {
        current = `${current} ${word}`;
      }
    }
    if (current.trim()) lines.push(current.trim());
  }
  return lines;
}

/**
 * Je znak napísateľný z naučených znakov? Medzera sa vždy považuje za známu —
 * nie je to kláves, ktorý by sa niekde „preberal“.
 * @param {string} char
 * @param {Set<string>} allowed
 */
function isAllowed(char, allowed) {
  return char === ' ' || allowed.has(char);
}

/**
 * Riadky textu, ktoré sa dajú napísať len z naučených znakov.
 *
 * Používa sa v režime „Text“: do lekcie sa pustia iba tie vety z našich textov,
 * ktoré žiak na danom stupni naozaj dokáže napísať. Ak sa nenájde dosť viet
 * (napr. v raných lekciách, kde ešte nie je Shift), režim Text sa doplní
 * generovanými vetami — nie cudzím textom.
 *
 * @param {PracticeText} text
 * @param {string[]} allowedKeys
 * @returns {string[]}
 */
export function textLinesForAlphabet(text, allowedKeys) {
  const allowed = new Set(allowedKeys);
  return textToLines(text).filter((line) => [...line].every((char) => isAllowed(char, allowed)));
}

/**
 * Všetky vety zo všetkých textov, ktoré sa dajú napísať z naučených znakov.
 * @param {string[]} allowedKeys
 * @returns {string[]}
 */
export function sentencesForAlphabet(allowedKeys) {
  const allowed = new Set(allowedKeys);
  /** @type {string[]} */
  const sentences = [];
  for (const text of PRACTICE_TEXTS) {
    for (const paragraph of text.paragraphs) {
      for (const sentence of paragraph.split(/(?<=[.!?])\s+/)) {
        const trimmed = sentence.trim();
        if (trimmed.length < 12 || trimmed.length > 68) continue;
        if (![...trimmed].every((char) => isAllowed(char, allowed))) continue;
        if (!sentences.includes(trimmed)) sentences.push(trimmed);
      }
    }
  }
  return sentences;
}
